<div class="row">
  <div *ngFor="let k of kpis; let i = index" id="adx-sb-kpi-{{i}}" class="col-12 col-md-6 col-lg-3">
    <widget-info
      [text]="k.text"
      [title]="k.title"
      [textSub]="k.overLine"
      [icon]="k.icon"
      [color]="k.color">
    </widget-info>
  </div>
</div>

<div class="row mt-24">
  <div class="col-12">
    <page-grid [gridConfig]="dailyGrid"/>
  </div>
</div>

<div class="row mt-24">
  <div class="col-12">
    <page-grid [gridConfig]="breakdownGrid"/>
  </div>
</div>

<div class="row mt-24">
  <div class="col-12">
    <page-grid [gridConfig]="bookingGrid"/>
  </div>
</div>
